"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TARGET_CLS = void 0;
var _configProvider = require("../../config-provider");
const TARGET_CLS = exports.TARGET_CLS = `${_configProvider.defaultPrefixCls}-wave-target`;